import { useMarkToolbarButton, useMarkToolbarButtonState } from "platejs/react";
import { type JSXElementConstructor, memo } from "react";
import { ToolbarButton } from "./toolbar";

export interface MarkToolbarButtonProps {
  nodeType: string;
  tooltip: string;
  clear?: string | string[];
  Icon: JSXElementConstructor<object>;
}

export const MarkToolbarButton = memo(function MarkToolbarButton({
  nodeType,
  tooltip,
  clear,
  Icon,
}: MarkToolbarButtonProps) {
  const state = useMarkToolbarButtonState({ clear, nodeType });
  const { props } = useMarkToolbarButton(state);

  return (
    <ToolbarButton
      Icon={Icon}
      onClick={props.onClick}
      pressed={props.pressed}
      tooltip={tooltip}
    />
  );
});
